import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';

import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import {dateStr, dateAndTime} from '../utils/TimeFormatter';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RC from '../utils/ReactiveClock';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import EditCustomer from '../components/EditCustomer';

let pageStyle = {
  margin:"1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}

const formStyle = {
  marginLeft: 16
};

export default
@observer class NewCustomerPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }
  constructor(props){
    super(props)
    this.state = { IdError: null }
  }

  // Return as utility method that updates a fied on a target object:
  updateField(target) {
    let self = this
    return function(event) {
      var field = event.target.dataset.propname;
      var value = event.target.value;
      if(field=='id' && !target.is_customer) value = value.toLowerCase()
      target[field]=value;
     
      

      if(field=='email') {
        AppModelUtils.checkIfEmailIsUnique(AppModel.newCustomerForm.adminUserForm);
      }
      
      if(field=='id' && target.is_customer) {
        AppModelUtils.checkIfCustomerIdUnique(AppModel.newCustomerForm.customer);
        if(value.length >= event.target.maxLength){
          self.setState({ IdError: uiMsg('RC_ID_MAX_LENGTH',"Maximum length of customer id is 36 characters") }) 
        }else{
          self.setState({ IdError: null }) 
        }
      }

      // Only for distributors to unlock the submit button - will only run once
      if(!AppModel.isSystemAdmin && !AppModel.newCustomerForm.customer.valid_as_new){
        AppModel.newCustomerForm.customer.id = AppModel.distributorCustomerId;
        AppModelUtils.checkIfCustomerIdUnique(AppModel.newCustomerForm.customer);
      }
    }
  }

  cancelUpdate() {
    AppModel.newCustomerForm.reset();
    this.context.router.goBack();
  }

  submitForm() {
    return AppModelUtils.registerNewCustomer()
    .then(()=> {
      this.context.router.push(`/customers`)
      return null;
    })
    .catch(()=> {
      console.log("New customer added.");
    });
  }

  render() {
    let form = AppModel.newCustomerForm;
    var operation = form.serverOperation;
    let customer = form.customer;
    let user = form.adminUserForm.user;
    return (
      <div style={pageStyle}>
        <PageLoading loading={
               AppModel.fetching_customer_segments
            || AppModel.fetching_job_types
            || AppModel.fetchingSupportedCountries
            || AppModel.fetchingSupportedLanguages
            || operation.waiting
          }>
          <h2 style={headerStyle}>{uiMsg('RC_REGISTER_CUSTOMER',"Register customer")}</h2>
          <List style={{paddingBottom:'0px'}}>
            <TextField data-propname="id"
                      floatingLabelText={uiMsg('RC_CUSTOMER_ID_REQ',"Customer Id (Required)")}
                      hintText={uiMsg('RC_CUSTOMER_ID_REQ_HINT',"Customer Id")}
                      value={AppModel.isSystemAdmin ? (customer.id || "") : AppModel.distributorCustomerId}
                      onChange={this.updateField(customer)}
                      fullWidth={true}
                      maxLength="36"
                      disabled={!AppModel.isSystemAdmin}
                      inputStyle={!AppModel.isSystemAdmin ? {color: 'rgba(0, 0, 0, 0.87)'} : {}}
                      errorText={!!customer.id
                        && customer.idChecked
                        && !customer.idCheckedAndOK ?
                      uiMsg('RC_ID_IN_USE',"This id is already in use") : this.state.IdError}
            />
          </List>
          <EditCustomer form={form} />
          <h2 style={headerStyle}>{uiMsg('RC_INITIAL_ADMIN_USER',"Initial admin user")}</h2>
          <TextField  data-propname="email"
                      floatingLabelText={uiMsg('RC_EMAIL_LOGIN',"Email (used to log in from web)")}
                      hintText={uiMsg('RC_EMAIL_LOGIN_HINT',"Email used for login.")}
                      fullWidth={true}
                      value={user.email || ""}
                      onChange={this.updateField(user)}
                      errorText={user.email && !user.validEmail ?
                        uiMsg('RC_INVALID_EMAIL',"Invalid email address"):(
                          user.email_checked && !user.email_unique ?
                            uiMsg('RC_ADDRESS_TAKEN',"Address registered with existing user") : null )}
            />
          <TextField data-propname="name"
                    floatingLabelText={uiMsg('RC_FULL_NAME',"Full name")}
                      hintText={uiMsg('RC_FULL_NAME_HINT',"Full name of user.")}
                      fullWidth={true}
                      value={user.name || ""}
                      onChange={this.updateField(user)}
          />
          <TextField  data-propname="id"
                      floatingLabelText={uiMsg('RC_USERNAME',"Username")}
                      hintText={uiMsg('RC_USERNAME_HINT',"Username for logging into disinfection machine.")}
                      value={user.id || ""}
                      onChange={this.updateField(user)}
                      fullWidth={true}
          />
          <TextField  data-propname="password"
                      floatingLabelText={uiMsg('RC_PASSWORD',"Password, to be communicated to user")}
                      hintText={uiMsg('RC_PASSWORD_HINT',"Password")}
                      fullWidth={true}
                      value={user.password || ""}
                      onChange={this.updateField(user)}
          />

          <h2>&nbsp;</h2>
          <Toolbar>
            <ToolbarGroup firstChild={true}></ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              <FlatButton
                      onTouchTap={this.cancelUpdate.bind(this)}>
                      {uiMsg('RC_CANCEL',"Cancel")}
              </FlatButton>
              <RaisedButton primary
                            onTouchTap={this.submitForm.bind(this)}
                            disabled={!customer.valid_as_new
                              || !user.isValidNewAdminUser
                              || !AppModel.checkingCustomerId} >
                            {uiMsg('RC_SUBMIT',"Submit")}
              </RaisedButton>
            </ToolbarGroup>
          </Toolbar>
          {/* added some space at the bottom to allow some scrolling */}
          <div style={{height:"3em"}}></div>
        </PageLoading>
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/NewCustomerPage.jsx
 **/